import { cn } from '@/lib/utils/tw-merge';

export const modalStyles = {
    base: 'ui-modal fixed inset-0 z-300 w-screen overflow-y-auto',
    /* A definite height, so the panel can be capped at it (`max-h-full`). */
    container: 'flex h-full justify-center p-4 md:items-center',
    /* The opening and closing transition of both elements below lives in
       components/modal.css, keyed on `ui-modal-panel` / `ui-modal-backdrop` and
       on the data attributes Headless UI sets. Do not add a transition,
       duration, easing or transform utility here: a utility beats that file
       whatever its specificity, and the two directions differ.

       The panel is the frame and never scrolls; the body inside it does. That
       keeps the close button in the panel's corner in reach however far the
       content has been scrolled. */
    panel: cn(
        'ui-modal-panel',

        'relative flex flex-col w-full max-h-full overflow-hidden bg-body text-body',
        'pointer-events-auto',
    ),
    body: 'ui-modal-body min-h-0 flex-1 overflow-y-auto overscroll-contain p-10 md:p-18',
    backdrop: 'ui-modal-backdrop fixed inset-0 bg-black/70',

    /* A 36px chip rather than a bare glyph, as the design draws it: the panel
       is a surface of its own, and a mark with no ground behind it lands on
       whatever content happens to sit in the corner. `current` for the fill
       means the chip is the panel's own ink at 8% — it follows the mode
       instead of assuming a dark panel. */
    closeButton: cn(
        'absolute',
        'size-9 rounded-full',
        'flex items-center justify-center',
        'bg-current/8 hover:bg-current/18 transition-colors duration-150',
        'cursor-pointer',
        'z-50', // ensure the close button stays clickable above modal content
    ),
    closeButtonPositions: {
        'top-right': 'top-4 right-4',
        'top-left': 'top-4 left-4',
    },

    // Container scale steps (AGENTS.md → Design contract → Containers); `full` is full screen.
    sizes: {
        '4xs': 'max-w-page-4xs',
        '3xs': 'max-w-page-3xs',
        '2xs': 'max-w-page-2xs',
        xs: 'max-w-page-xs',
        sm: 'max-w-page-sm',
        md: 'max-w-page-md',
        lg: 'max-w-page-lg',
        xl: 'max-w-page-xl',
        full: '!size-full',
    },
} as const;
